import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';

export interface IAnimationFeature extends IBaseDrawerFeature {
    renderAnimationEditor(): ReactElement;
}

export const IAnimationFeature = Symbol.for('feature:drawer-animation');

DynamicLoaderRegistry.merge(IAnimationFeature, {
    useFactory: async () => {
        const { AnimationFeature } = await import('./animation-feature');
        return AnimationFeature;
    },
    on: loadTask,
});
